import { pb } from "@/utils/PocketBaseAdapter";

const getV2Origin = () => {
  if (window.location.hostname === 'localhost') {
    return 'http://localhost:3000'
  }

  const hostParts = window.location.hostname.split('.')
  if (hostParts.length < 2) {
    return window.location.origin
  }

  const [site, ...domainParts] = hostParts
  const v2Site = site.endsWith('v2') ? site : `${site}v2`
  const v2Host = `${v2Site}.${domainParts.join('.')}`
  const port = window.location.port ? `:${window.location.port}` : ''

  return `${window.location.protocol}//${v2Host}${port}`
}

const v2Url = getV2Origin();

const HANDOFF_TOKEN_KEY = 'bbv1token'
const HANDOFF_THEME_KEY = 'bbv1theme'
const THEME_STORAGE_KEY = '-theme'

const buildV2BridgeUrl = (path: string) => {
  const token = `${pb.authStore.token || ''}`.trim()
  const themeMode = `${window.localStorage.getItem(THEME_STORAGE_KEY) || 'system'}`.trim().toLowerCase()
  const targetPath = path.startsWith('/') ? path : `/${path}`
  const bridgeUrl = new URL(`${v2Url}${targetPath}`)
  bridgeUrl.searchParams.set('navMode', 'v1bridge')

  if (token !== '') {
    bridgeUrl.hash = `${HANDOFF_TOKEN_KEY}=${encodeURIComponent(token)}`
  }

  if (['light', 'dark', 'system'].includes(themeMode)) {
    const hashParams = new URLSearchParams(bridgeUrl.hash.startsWith('#') ? bridgeUrl.hash.slice(1) : bridgeUrl.hash)
    hashParams.set(HANDOFF_THEME_KEY, themeMode)

    bridgeUrl.hash = hashParams.toString()
  }

  return bridgeUrl.toString()
}

const navigateToV2Bridge = async (path: string) => {
  const hasToken = `${pb.authStore.token || ''}`.trim() !== ''

  if (hasToken) {
    try {
      await pb.collection('users').authRefresh()
    } catch {
      return
    }
  }

  window.location.assign(buildV2BridgeUrl(path))
}

export default [
  { heading: "Apps" },
  {
    title: "Dockets",
    to: "dockets",
    icon: { icon: "mdi-cart" },
    disable: false,
    isSetToVisible: true,
  },
  {
    title: "POS",
    to: "pos",
    icon: { icon: "mdi-network-pos" },
    disable: false,
    isSetToVisible: true,
  },
  {
    title: "Staff TimeClock",
    to: "staff-timeclock",
    icon: { icon: "mdi-timer-sync-outline" },
    disable: false,
    isSetToVisible: true,
  },
  {
    title: "Prep",
    href: buildV2BridgeUrl('/prep'),
    onClick: () => {
      void navigateToV2Bridge('/prep')
    },
    icon: { icon: "mdi-room-service-outline" },
    disable: false,
    isSetToVisible: true,
  },
];
